import React, { useEffect, useState } from "react";
import { SlovHeader } from "./KCATSNIGHT_slovHeader";

const MAX_MESSAGES = 5;
const MAX_LENGTH = 400;

const normalizeChats = (rawChats) => {
    if (!Array.isArray(rawChats)) return [];

    return rawChats.map((chat) => ({
        chatId: Number(chat?.[0]),
        messages: Array.isArray(chat?.[1]) ? chat[1] : [],
    }));
};

const countMessages = (messages, senderIndex) =>
    messages.filter((message) => Number(message?.[1]) === Number(senderIndex)).length;

export const KCatsTuringSpecialScreen = (props) => {
    const data = props.data || { round: 0, chats: [] };

    const [chats, setChats] = useState(normalizeChats(data.chats));
    const [counts, setCounts] = useState({});
    const [drafts, setDrafts] = useState({});

    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    useEffect(() => {
        const normalized = normalizeChats(data.chats);
        const initialCounts = {};

        normalized.forEach((chat) => {
            initialCounts[chat.chatId] = [
                countMessages(chat.messages, 0),
                countMessages(chat.messages, 1),
            ];
        });

        setChats(normalized);
        setCounts(initialCounts);
        setDrafts({});
    }, [data.round, data.chats]);

    useEffect(() => {
        if (!props.update) return;

        const updateChatId = Number(props.update.chatId);

        setChats((oldChats) =>
            oldChats.map((chat) =>
                chat.chatId === updateChatId
                    ? { ...chat, messages: Array.isArray(props.update.messages) ? props.update.messages : [] }
                    : chat
            )
        );

        setCounts((oldCounts) => ({
            ...oldCounts,
            [updateChatId]: [
                Number(props.update.count0) || 0,
                Number(props.update.count1) || 0,
            ],
        }));
    }, [props.update]);

    const sendMessageToChat = (chatId) => {
        const currentText = String(drafts[chatId] || "");
        const trimmedText = currentText.trim();
        const myCount = counts[chatId]?.[0] || 0; // KCats is always sender index 0.

        if (myCount >= MAX_MESSAGES || trimmedText.length === 0) {
            return;
        }

        props.sendMessage(
            `sendtoserver|slov\\addtext\\kcatsuring_chat\\${chatId}\\${encodeURIComponent(trimmedText)}`
        );

        setDrafts((oldDrafts) => ({ ...oldDrafts, [chatId]: "" }));
    };

    const handleKeyDown = (event, chatId) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            sendMessageToChat(chatId);
        }
    };

    return (
        <div id="game">
            <SlovHeader />

            <div style={{ margin: "14px auto", width: "94%", maxWidth: "980px" }}>
                <div className="divtext_slov"><b>Тест Кикецюринга</b></div>
                <div style={{ marginTop: "6px", color: "#333" }}>Раунд {data.round}</div>
                <div style={{ marginTop: "8px", fontSize: "14px", color: "#666" }}>
                    Вы — KCats. У вас несколько независимых чатов. В каждом можно отправить до 5 сообщений.
                </div>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                        gap: "12px",
                        marginTop: "16px",
                        alignItems: "start",
                    }}
                >
                    {chats.map((chat, chatIndex) => {
                        const chatCounts = counts[chat.chatId] || [0, 0];
                        const myCount = chatCounts[0] || 0;
                        const limitReached = myCount >= MAX_MESSAGES;
                        const draft = String(drafts[chat.chatId] || "");
                        const rejected =
                            props.reject &&
                            Number(props.reject.chatId) === Number(chat.chatId);

                        return (
                            <div
                                key={chat.chatId}
                                style={{
                                    border: "1px solid #cfcfcf",
                                    borderRadius: "12px",
                                    background: "#f7f7f7",
                                    padding: "10px",
                                }}
                            >
                                <div style={{ fontWeight: "bold", marginBottom: "8px", color: "#222" }}>
                                    Чат {chatIndex + 1}
                                </div>

                                <div
                                    style={{
                                        height: "250px",
                                        overflowY: "auto",
                                        padding: "8px",
                                        borderRadius: "8px",
                                        background: "#eeeeee",
                                    }}
                                >
                                    {chat.messages.length === 0 ? (
                                        <div style={{ color: "#888", textAlign: "center", paddingTop: "95px" }}>
                                            Сообщений пока нет
                                        </div>
                                    ) : (
                                        chat.messages.map((message, index) => {
                                            const isMine = Number(message?.[1]) === 0;
                                            return (
                                                <div
                                                    key={`${index}-${message?.[1]}`}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: isMine ? "flex-end" : "flex-start",
                                                        marginBottom: "7px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            maxWidth: "86%",
                                                            padding: "7px 9px",
                                                            borderRadius: "10px",
                                                            background: isMine ? "#dfeeff" : "#ffffff",
                                                            border: "1px solid #d5d5d5",
                                                            color: "#111",
                                                            whiteSpace: "pre-wrap",
                                                            overflowWrap: "anywhere",
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        <div style={{ fontSize: "10px", color: "#777", marginBottom: "2px" }}>
                                                            {isMine ? "Вы" : "Собеседник"}
                                                        </div>
                                                        {String(message?.[0] ?? "")}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>

                                <div style={{ marginTop: "8px", fontSize: "13px", color: limitReached ? "#a00000" : "#444" }}>
                                    Ваши сообщения: {myCount}/{MAX_MESSAGES}
                                </div>

                                {rejected && (
                                    <div style={{ marginTop: "5px", color: "#a00000", fontSize: "12px" }}>
                                        Лимит сообщений в этом чате исчерпан.
                                    </div>
                                )}

                                <textarea
                                    autoComplete="off"
                                    className="FormInput"
                                    style={{ width: "91%", minHeight: "58px", marginTop: "8px", resize: "vertical" }}
                                    placeholder={limitReached ? "Лимит сообщений исчерпан" : "Сообщение..."}
                                    maxLength={MAX_LENGTH}
                                    value={draft}
                                    disabled={limitReached}
                                    onChange={(event) =>
                                        setDrafts((oldDrafts) => ({
                                            ...oldDrafts,
                                            [chat.chatId]: event.target.value,
                                        }))
                                    }
                                    onKeyDown={(event) => handleKeyDown(event, chat.chatId)}
                                />

                                <div style={{ fontSize: "11px", color: "#777", marginTop: "2px" }}>
                                    {draft.length}/{MAX_LENGTH}
                                </div>

                                <button
                                    type="button"
                                    disabled={limitReached || draft.trim().length === 0}
                                    onClick={() => sendMessageToChat(chat.chatId)}
                                    style={{ marginTop: "7px" }}
                                >
                                    Отправить
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
